import { ChangeDetectionStrategy, Component, ElementRef, OnChanges, Renderer2 } from '@angular/core';
import { FireAndFlowerShelfTalkerContentViewModel } from './fire-and-flower-shelf-talker-content-view-model';
import { ShelfTalkerCardContentComponent } from '../../shelf-talker-card-content.component';

@Component({
  selector: 'app-fire-and-flower-shelf-talker-content',
  templateUrl: './fire-and-flower-shelf-talker-content.component.html',
  styleUrl: './fire-and-flower-shelf-talker-content.component.scss',
  providers: [FireAndFlowerShelfTalkerContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FireAndFlowerShelfTalkerContentComponent extends ShelfTalkerCardContentComponent implements OnChanges {
  constructor(
    public viewModel: FireAndFlowerShelfTalkerContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
